<template>
  <div>
    <v-menu bottom
            left>
      <v-btn slot='activator'
             color="grey lighten-1"
             flat>
        {{ currentLanguage}}
      </v-btn>
      <v-list>
        <v-list-tile v-for='item in items'
                     :key='item.key'
                     :value='item.key'
                     @click='changeLanguage(item, false)'>
          <v-list-tile-title>{{ item.langName }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import store from '@/store';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import _ from 'lodash';

export default {
  name: 'ChangeLanguageDropdown',
  data() {
    return {
      items: [],
      allLanguages: [],
      localeSelected: this.$i18n.locale,
      currentLanguage: store.state.langSelected.langName
    };
  },

  created() {
    _.each(store.state.langs, obj => {
      this.allLanguages.push(_.merge({ key: obj.langIso }, obj));
    });
    EventBus.$on(keys.countrySelected, this.updateLanguages);
  },

  destroyed() {
    EventBus.$off(keys.countrySelected, this.updateLanguages);
  },

  methods: {
    updateLanguages() {
      this.items = _.intersectionWith(this.allLanguages, store.state.countryConstantsSelected.langs, (itAll, ctyLang) => {
        return itAll.key === ctyLang;
      });

      this.localeSelected = this.items[0].key;

      this.changeLanguage(this.items[0], true);
    },
    changeLanguage(langSelected, init) {
      this.$i18n.locale = langSelected.key;
      this.localeSelected = langSelected.key;
      this.currentLanguage = langSelected.langName;
      store.commit('CHANGE_LANG_SELECTED', { langSelected: this.localeSelected, init: init });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ChangeLanguageDropdown.vue